'use client';

import type { ReactNode } from 'react';
import { VStack } from '@terra/ui-styled-system';
import { AttackerCard } from './AttackerCard';
import type { HITLContentContext } from '../../tool-config-types';
import type { AttackerToolInput } from './types';

function parseAttackerData(data: unknown): AttackerToolInput | null {
  if (!data || typeof data !== 'object') return null;

  const input = data as Record<string, unknown>;

  if (!input.signalId && !input.userAttackPrompt) return null;

  return {
    signalId: String(input.signalId || ''),
    endpointId: input.endpointId ? String(input.endpointId) : undefined,
    harEntryId: input.harEntryId ? String(input.harEntryId) : undefined,
    credentialId: input.credentialId ? String(input.credentialId) : undefined,
    userNotes: input.userNotes ? String(input.userNotes) : undefined,
    userAttackPrompt: String(input.userAttackPrompt || ''),
  };
}

export const renderAttackerContent = (ctx: HITLContentContext): ReactNode => {
  const attackerData = ctx.extractedData
    .map((item) => parseAttackerData(item))
    .filter((item): item is AttackerToolInput => item !== null);

  if (attackerData.length === 0) return null;

  return (
    <VStack alignItems="stretch" gap={2} width="100%">
      {attackerData.map((data, index) => (
        <AttackerCard key={index} data={data} />
      ))}
    </VStack>
  );
};
